import React, { useCallback } from 'react';
import { Button } from 'antd';
import { AccentButtonStyled } from './SbButton.styles';

export const BUTTON_TYPE = {
  PRIMARY:   'primary',
  SECONDARY: 'secondary',
  ACTION:    'action',
  RED:       'red',
  DANGER:    'red', // backward compat alias
  ACCENT:    'accent', // brand mint — used for auth actions (sign in, send OTP, reset, …)
};

// Maps buttonType → Ant Design native props
// Colors are fully controlled by SB_ANT_THEME.components.Button tokens
const TYPE_PROPS = {
  primary:   { type: 'primary' },
  secondary: { type: 'default' },
  action:    { type: 'text' },
  red:       { type: 'primary', danger: true },
  accent:    { type: 'primary' }, // AccentButtonStyled overrides the colours (see SbButton.styles)
};

const SbButton = ({ buttonType, onClick, data, stopPropagation = false, preventDefault = false, ...rest }) => {
  const handleOnClick = useCallback(
    (event) => {
      if (stopPropagation) event.stopPropagation();
      if (preventDefault) event.preventDefault();
      onClick?.(event, data);
    },
    [data, onClick, stopPropagation, preventDefault],
  );

  const ButtonComponent = buttonType === 'accent' ? AccentButtonStyled : Button;

  return <ButtonComponent {...(TYPE_PROPS[buttonType] ?? {})} {...rest} onClick={handleOnClick} />;
};

export default SbButton;
